export default __webpack_public_path__ + "static/6856-805e51416fb7884c87dac015f18a04f7.jpg";